import { TimelineItemModel } from "../models/timelineModels";

export const timelineData: {
    [key: string]: TimelineItemModel[];
} = {
    work: [
        new TimelineItemModel(
            "Android Security Researcher",
            "Matrix Ltd.",
            2017,
            2018,
            [],
            ["Android system/apps vulnerabilities and security research"],
            [
                "Android",
                "Linux",
                "Network Security",
                "Wireshark",
                "Fiddler",
                "Charles",
            ]
        ),
        new TimelineItemModel(
            "Cyber Security R&D",
            "8200 Unit (Initial Compulsory Service)",
            2018,
            2020,
            [],
            [
                "Development of robust server side applications with heavy load",
                "Large scale delicate Linux Kernel modifications, research and development",
            ],
            [
                "Golang",
                "Python",
                "Network Security",
                "Linux & Kernel Development",
                "Redis",
                "SQL",
                "C",
                "Javascript",
                "Gitlab CI",
            ]
        ),
        new TimelineItemModel(
            "Android Cyber Security R&D",
            "8200 Unit (Reserves)",
            2024,
            2024,
            [],
            ["Android low level apps and system development"],
            ["Android", "Linux", "Root", "Python"]
        ),
        new TimelineItemModel(
            "Ministry of Defense",
            "Cyber Security Consultant",
            2022,
            2023,
            [],
            [
                "Consultant and CTO for a cyber security division under the Ministry of Defense",
            ],
            ["Network Security", "OSINT", "Product Management", "Cellular Protocols"]
        ),
        new TimelineItemModel(
            "Full Stack Web Developer",
            "Part Time Freelance",
            2014,
            2016,
            [],
            ["Developed websites and services for local after school teaching center"],
            ["AngularJS", "HTML/CSS", "Javascript", "NodeJS"]
        ),
        new TimelineItemModel(
            "Independent Developer",
            "Entrepreneur and Open Source Contributor",
            2014,
            "Present",
            [
                { url: "https://rosenpin.io/showcase", text: "Open Source Projects" },
                { url: "https://github.com/rosenpin", text: "GitHub Profile" },
                {
                    url: "https://play.google.com/store/apps/dev?id=5609675488735208213",
                    text: "Google Play Account",
                },
            ],
            [
                "20+ million app downloads, endless media coverage, and an exit",
                "Open-source owner and contributor, including contributions to renowned projects like Signal",
                "Adept at UI/UX design, specializing in Google's Material Design principles",
            ],
            [
                "Product Management",
                "Android (R&D)",
                "Flutter",
                "Python",
                "AI",
                "React",
                "Kotlin/Java",
                "Adobe Suite",
                "Linux",
            ]
        ),
        new TimelineItemModel(
            "AI Software Engineer",
            "Mixtiles",
            2024,
            "Present",
            [],
            [
                "Architected production Python server with AI capabilities serving millions of users",
                "Developed iOS features and AI model integrations using CLIP embeddings",
                "Designed scalable AWS infrastructure using CDK for production deployment",
                "Championed adoption of AI tools to enhance teams productivity",
            ],
            ["AI", "Flutter", "Rust", "Python", "iOS", "AWS"]
        ),
    ],
    projects: [
        new TimelineItemModel(
            "Spidey-Sense",
            "Wearable device that alerts you to danger",
            2023,
            2023,
            [
                {
                    url: "https://github.com/rosenpin/Spidey-Sense",
                    text: "Devpost",
                },
            ],
            [
                "Hackathon project: Awareness-enhancing hat for dangerous environments",
                "Uses camera and ML for threat detection",
            ],
            ["Python", "ML", "Hardware", "Linux"],
            "spidey.webp",
            6
        ),
        new TimelineItemModel(
            "Pokémon GO+",
            "Support app for Pokémon GO",
            2016,
            2016,
            [
                {
                    url: "https://github.com/rosenpin-deprecated/More-For-GO",
                    text: "GitHub",
                },
            ],
            [
                "Reverse engineered to add features like favorite Pokémon notifications, battery optimization, and more",
            ],
            ["Android", "Research", "Undocumented APIs", "Java"],
            "pogo.webp",
            3
        ),
        new TimelineItemModel(
            "Good Morning Server",
            "Web server that provides a daily good morning image",
            2019,
            2019,
            [
                {
                    url: "https://image.rosenpin.io/",
                    text: "Live Demo",
                },
                {
                    url: "https://github.com/rosenpin/good-morning",
                    text: "GitHub",
                },
                {
                    url: "https://github.com/rosenpin/good-morning/blob/master/design.png",
                    text: "Architecture Design",
                },
            ],
            [
                "Uses Google Image Search API for daily images",
                "Clean code principles and customizable configuration",
            ],
            ["Golang", "GitHub API", "Clean Code", "Design Patterns"],
            "goodmorning.webp",
            5
        ),
        new TimelineItemModel(
            "Git Project Showcaser",
            "Web service to showcase your top git projects",
            2018,
            2018,
            [
                {
                    url: "https://rosenpin.io/showcase",
                    text: "Live Demo",
                },
                {
                    url: "https://github.com/rosenpin/git-project-showcaser",
                    text: "GitHub",
                },
            ],
            [
                "0 Javascript, entirely server side",
                "Designed with clean code principles",
            ],
            ["Golang", "GitHub API", "Clean Code", "Design Patterns"],
            "gitshowcase.webp",
            4
        ),
        new TimelineItemModel(
            "Geofilters For Snapchat",
            "Mock location based filters for Snapchat",
            2016,
            2016,
            [
                {
                    url: "https://www.youtube.com/watch?v=u2vig7dXf_o",
                    text: "Video Coverage",
                },
            ],
            [
                "Used Android's mock location to control Snapchat's geofilters",
                "Over 500,000 users",
            ],
            ["Android", "Product Management"],
            "geofilters.png",
            2
        ),
        new TimelineItemModel(
            "ALLess",
            "Control a doll with your eyes using an exoskeleton",
            2022,
            2022,
            [
                {
                    url: "https://github.com/rosenpin/ALLess/blob/main/README.md",
                    text: "Devpost",
                },
            ],
            [
                "POC pain relief solution for ALS patients",
                "Eye recognition controls motor-powered exoskeleton",
            ],
            ["Python", "ML", "Hardware", "Linux"],
            "alless.webp",
            5
        ),
        new TimelineItemModel(
            "Goaly",
            "AI Habit Tracker with Google Calendar integration",
            2022,
            2022,
            [
                {
                    url: "https://www.androidpolice.com/hands-on-with-goaly/",
                    text: "AP Coverage",
                },
                {
                    url: "https://play.google.com/store/apps/details?id=io.rosenpin.goals",
                    text: "Google Play",
                },
                {
                    url: "https://apps.apple.com/il/app/goaly-ai-habit-tracker/id6444002356",
                    text: "App Store",
                },
                {
                    url: "https://www.ynet.co.il/digital/mobile/article/bylwxxihi",
                    text: "Media Coverage",
                },
                {
                    url: "https://youtu.be/T-1Z3nsbwLk?t=277",
                    text: "YouTube Coverage",
                },
            ],
            ["AI-powered habit tracker with smart calendar scheduling"],
            ["Flutter", "AI", "Google Cloud APIs"],
            "goaly.png",
            7
        ),
        new TimelineItemModel(
            "Todoist MCP Server",
            "Remote MCP integration for task management",
            2025,
            2025,
            [
                {
                    url: "https://todoistmcp.rosenpin.io/",
                    text: "Live Service",
                },
            ],
            [
                "Built one of the first remote Model Context Protocol servers for LLM integration",
                "Enables Claude and other AI assistants to directly manage Todoist tasks",
            ],
            ["MCP", "API Integration", "AI/LLM", "Production Systems"],
            "todoistmcp.webp",
            11
        ),
        new TimelineItemModel(
            "Mobile MCP Framework",
            "Bringing Model Context Protocol to mobile devices",
            2025,
            "Present",
            [
                {
                    url: "https://github.com/Mobile-MCP/Mobile-MCP",
                    text: "GitHub",
                },
            ],
            [
                "Enables locally-running LLMs to discover and use tools from 3rd party apps",
                "Two-sided framework bridging AI assistants with native mobile capabilities",
                "Standardized interface for AI-app integration on Android",
            ],
            ["Android", "Kotlin", "AI Integration", "AIDL", "Open Source"],
            "mobilemcp.webp",
            12
        ),
        new TimelineItemModel(
            "Open Source Projects",
            "Owner and Contributor to **many** open source projects",
            2014,
            "Present",
            [
                {
                    url: "https://rosenpin.io/showcase",
                    text: "Top Open Source Projects",
                },
                {
                    url: "https://github.com/rosenpin/todoist-service",
                    text: "Todoist Plugins",
                },
                {
                    url: "https://github.com/rosenpin/i3-agenda",
                    text: "Popular i3 plugin",
                },
                {
                    url: "https://github.com/rosenpin",
                    text: "GitHub Profile",
                },
            ],
            [
                "100+ projects, including contributions to Signal",
                "2200+ stars, 350+ forks across projects",
            ],
            ["Android", "Python", "Kotlin/Java", "Linux", "Management", "Git"],
            "open-source.png",
            8
        ),
        new TimelineItemModel(
            "FastTest",
            "Auto generated math tests for students",
            2014,
            2015,
            [],
            [
                "Web service for auto-generated math practice tests",
                "Freelance project for after-school teaching center",
            ],
            ["AngularJS", "Material Design", "NodeJS", "HTML/CSS", "Git"],
            "fasttest.webp",
            1
        ),
        new TimelineItemModel(
            "Assist-Me",
            "A voice assistant with context aware capabilities",
            2014,
            2014,
            [],
            [
                "Local voice assistant inspired by early Siri and Google Now",
                "Learned from user's phone usage patterns",
            ],
            ["Android", "Java", "Git", "TTS/STT"],
            "assistme.webp",
            1
        ),
        new TimelineItemModel(
            "Hadasha",
            "Hebrew AI mindful news app",
            2024,
            2024,
            [
                {
                    url: "https://hadasha.rosenpin.io/",
                    text: "Website",
                },
                {
                    url: "https://play.google.com/store/apps/details?id=io.rosenpin.news",
                    text: "Google Play",
                },
                {
                    url: "https://apps.apple.com/il/app/%D7%97%D7%93%D7%A9%D7%94-%D7%A2%D7%99%D7%AA%D7%95%D7%A0%D7%95%D7%AA-%D7%A7%D7%A9%D7%95%D7%91%D7%94/id6476049358?uo=2",
                    text: "App Store",
                },
            ],
            [
                "AI-curated important news delivery",
                "Intelligently combines news from different sources to find the consensus",
            ],
            [
                "Python",
                "Flutter",
                "Microservices",
                "AI",
                "Amazon Bedrock",
                "OpenAI",
                "Firebase",
                "AWS",
            ],
            "hadasha.webp",
            10
        ),
        new TimelineItemModel(
            "DM Me",
            "Mobile chat apps unifier",
            2021,
            2021,
            [
                {
                    url: "https://play.google.com/store/apps/details?id=io.rosenpin.dmme",
                    text: "Google Play",
                },
                {
                    url: "https://www.ynet.co.il/digital/mobile/article/S1DlMLYg00",
                    text: "Media Coverage",
                },
                {
                    url: "https://www.youtube.com/watch?v=MM24rF7ln34",
                    text: "TV Interview",
                },
                {
                    url: "https://www.netzwelt.de/news/185429-dm-me-whatsapp-telegram-signal-app-verraet-welchen-messenger-nutzt.html",
                    text: "German Media Coverage",
                },
            ],
            [
                "Unified chat app for multiple platforms (WhatsApp, Telegram, Signal)",
                "Uses undocumented Android APIs for secure messaging",
            ],
            ["Android", "Research", "Undocumented APIs", "Product Management"],
            "dmme.webp",
            7
        ),
        new TimelineItemModel(
            "Always On AMOLED",
            "The most popular Always On Display app",
            2016,
            2024,
            [
                {
                    url: "https://play.google.com/store/apps/details?id=com.tomer.alwayson",
                    text: "Google Play",
                },
                {
                    url: "https://github.com/rosenpin/always-on-amoled",
                    text: "GitHub Archive",
                },
                {
                    url: "https://www.youtube.com/watch?v=6tsQs3Eq9JY",
                    text: "YouTube Coverage",
                },
                {
                    url: "https://naijaknowhow.net/always-on-display-apps/",
                    text: "Media Coverage",
                },
                {
                    url: "https://www.androidpolice.com/2018/10/19/dmca-failure-play-store-automated-takedowns-hit-indie-app-always-display-amoled/",
                    text: "AP Coverage",
                },
            ],
            [
                "Over **20 million** installs",
                "Successfully exited and sold it in 2023",
            ],
            [
                "Android",
                "Kotlin/Java",
                "Jetpack Compose",
                "Material Design",
                "Product Management",
                "Marketing",
            ],
            "alwaysonamoled.webp",
            9
        ),
    ],
    education: [
        new TimelineItemModel(
            "University of Essex",
            "B.Sc. in Neuroscience & Philosophy",
            2023,
            2023,
            [],
            ["Study abroad at Essex, England"],
            ["MRI & EEG analysis"]
        ),
        new TimelineItemModel(
            "Ben Gurion University",
            "B.Sc. in Cognitive Sciences & Philosophy",
            2021,
            2024,
            [],
            [],
            [
                "Brain Computer Interfaces",
                "Machine Learning",
                "Philosophical Reading/Writing",
            ]
        ),
        new TimelineItemModel(
            'Apollo Course ("Mamas Shetach")',
            "8200 software engineering course",
            2018,
            2019,
            [],
            [
                "6 months, 12 hours a day, 6 days a week military cybersecurity R&D course",
                "Focused on clean code, design patterns, and best practices",
                "Additional 3 months OJT in leading cyber R&D team",
            ],
            [
                "Clean Code",
                "C/C++",
                "Python",
                "Operating Systems",
                "Network Security",
                "Javascript",
                "Git",
            ]
        ),
    ],
    misc: [
        new TimelineItemModel(
            "Wingate Institute",
            "Gym Instruction Course",
            2019,
            2019,
            [],
            ["Graduated with excellence"],
            ["Anatomy", "Personal Training", "Nutrition"],
            null,
            2
        ),
        new TimelineItemModel(
            "Entrepreneurship Course",
            "Mentor & Teacher",
            2024,
            2024,
            [],
            ["Taught programming, design, and entrepreneurship to high school students"],
            ["Teaching", "Entrepreneurship", "Volunteer"],
            null,
            10
        ),
        new TimelineItemModel(
            "Shapira Elderly Community Center",
            "Computer Teacher and Caregiver",
            2021,
            2021,
            [],
            ["Taught elderly how to use computers and the internet"],
            ["Teaching", "Volunteer"],
            null,
            4
        ),
        new TimelineItemModel(
            "Ben Gurion University",
            "New Student Orientation Mentor",
            2022,
            2022,
            [],
            ["Helped new students settle in and get accustomed to university life"],
            ["Lecturing", "Volunteer"],
            null,
            7
        ),
        new TimelineItemModel(
            "8200 Cyber Course",
            "Support Staff",
            2019,
            2020,
            [],
            ["Helped teaching and training new recruits during their cyber course"],
            ["Teaching", "Cyber"],
            null,
            9
        ),
        new TimelineItemModel(
            "Volunteer Shepherd",
            "A Local Farm",
            2020,
            2020,
            [],
            ["Volunteered at a local farm during the pandemic"],
            ["Goats", "Volunteer"],
            null,
            5
        ),
        new TimelineItemModel(
            "FIRST Robotics",
            "Team Mentor & Teacher",
            2016,
            2017,
            [],
            ["Instructed high school students robotic team"],
            ["Teaching"],
            null,
            6
        ),
    ],
};